import Vue from 'vue';
import VueI18n from 'vue-i18n';

Vue.use(VueI18n);

const messages = {
  'en': {
    'SEARCH': 'Search',
    'SELECT_LANGUAGE': 'Select language',
    'header': {
      'ABOUT': 'About',
      'COLLECTIONS': 'Collections',
      'SEARCH_GUIDE': 'Search Guide',
      'FEEDBACK': 'Feedback',
      'EXTENSION': 'Extension',
      'EXTENSION_ARIA': 'Browser Extension'
    },
    'hero': {
      'TITLE': 'Search for content to reuse',
      'PLACEHOLDER': 'I would like to see...',
      'LICENSE_STATEMENT': 'All our content is under Creative Commons licenses.',
      'CAPTION_BEFORE_LINK': 'Learn more',
      'CAPTION_LINK': 'about CC licenses.',
      'CAPTION_AFTER_LINK': '',
      'checkboxes': {
        'TITLE': 'I want something I can'
      },
      'help': {
        'CAPTION_BEFORE_LINK': 'Go to the',
        'CAPTION_LINK': 'old CC Search',
        'CAPTION_AFTER_LINK': 'portal'
      }
    },
    'footer': {
      'LOGO_ARIA_LABEL': 'Creative Commons website',
      'menu': {
        'CONTACT': 'Contact',
        'PRIVACY': 'Privacy',
        'POLICIES': 'Policies',
        'TERMS': 'Terms'
      },
      'license': {
        'PART_1_BEFORE_LINK': 'Except where otherwise ',
        'PART_1_LINK': 'noted,',
        'PART_1_AFTER_LINK': '',
        'PART_2_BEFORE_LINK': 'content on this site is licensed under a ',
        'PART_2_LINK': 'Creative Commons Attribution 4.0 International license.',
        'PART_2_AFTER_LINK': ''
      },
      'FONT_AWESOME_ATTRIBUTION': 'Icons by Font Awesome.',
      'donate-section': {
        'TITLE': 'Our work relies on you!',
        'SUB_TITLE': 'Help us keep the internet free and open.',
        'BUTTON_TEXT': 'Donate Now'
      }
    },
    'license-types': {
      'COMMERCIAL': 'Use commercially',
      'MODIFY': 'Modify or adapt'
    }
  },
  'ja': {
    'SEARCH': '検索',
    'SELECT_LANGUAGE': '言語を変更',
    'header': {
      'ABOUT': 'CCについて',
      'COLLECTIONS': 'コレクション',
      'SEARCH_GUIDE': '検索ガイド',
      'FEEDBACK': 'フィードバック',
      'EXTENSION': '拡張',
      'EXTENSION_ARIA': 'ブラウザ拡張'
    },
    'hero': {
      'TITLE': '再利用するコンテンツを検索',
      'PLACEHOLDER': '検索したいこと',
      'LICENSE_STATEMENT': 'すべてのコンテンツは、クリエイティブコモンズライセンスを使用しています。',
      'CAPTION_BEFORE_LINK': '',
      'CAPTION_LINK': 'CCライセンスの詳細',
      'CAPTION_AFTER_LINK': 'をご覧ください。',
      'checkboxes': {
        'TITLE': 'この種の資料を探しています'
      },
      'help': {
        'CAPTION_BEFORE_LINK': '',
        'CAPTION_LINK': '以前のCC検索ポータル',
        'CAPTION_AFTER_LINK': 'を使用する'
      }
    },
    'footer': {
      'LOGO_ARIA_LABEL': 'クリエイティブ・コモンズのウェブサイト',
      'menu': {
        'CONTACT': '連絡先',
        'PRIVACY': 'プライバシー',
        'POLICIES': 'ポリシー',
        'TERMS': '条項'
      },
      'license': {
        'PART_1_BEFORE_LINK': '',
        'PART_1_LINK': '特に明記されていない限り、',
        'PART_1_AFTER_LINK': '',
        'PART_2_BEFORE_LINK': 'このサイトのコンテンツは、',
        'PART_2_LINK': 'Creative Commons Attribution 4.0 Internationalライセンス',
        'PART_2_AFTER_LINK': 'の下でライセンスされています。'
      },
      'FONT_AWESOME_ATTRIBUTION': 'Font Awesomeによるアイコン。',
      'donate-section': {
        'TITLE': 'CCはあなたにかかっています！',
        'SUB_TITLE': 'インターネットを自由でオープンな状態に保つためにご協力ください。',
        'BUTTON_TEXT': '寄付してください'
      }
    },
    'license-types': {
      'COMMERCIAL': '商用利用',
      'MODIFY': '変更または適応'
    }
  }
};

export default new VueI18n({
  locale: 'en',
  fallbackLocale: 'en', // set fallback locale
  messages // set locale messages
});
